import * as React from 'react'

/**
 * A tile-shaped loading placeholder.
 *
 * Reuses the MovieTile geometry classes so a skeleton cell is exactly the size of
 * the tile that will replace it — that identity is what keeps the swap free of any
 * layout shift, in a scrolling row ({@link Showcase}) as in a grid (the catalogue
 * pages). Purely decorative, so it is hidden from assistive technology; the
 * container it fills is what announces that it is busy.
 */
export function MovieTileSkeleton () {
  return (
    <div className='mlsg-movie-tile mlsg-movie-tile--skeleton' aria-hidden='true'>
      <div className='mlsg-movie-tile__media mlsg-skeleton' />
      <div className='mlsg-movie-tile__info'>
        <div className='mlsg-movie-tile__title'>
          {/* A non-breaking space gives the placeholder a real text line box, so
              the caption keeps the same height with or without a loaded title. */}
          <span className='mlsg-skeleton mlsg-skeleton--text'>&nbsp;</span>
        </div>
      </div>
    </div>
  )
}
